import { space18, BWHeader, getStyle } from "../dist/helpers"
import mattG from "../images/Found/mattG.png"
import MacOS from "../images/Found/MacOS.jpg"
import Mark from "../images/Found/Mark.png"
import UpDate from "../images/Found/UpDate.png"
import Kaloi from "../images/Found/Kaloi.png"
import ThreeJS from "../images/Found/ThreeJS.png"
import Mount from "../images/Found/Mount.png"
import Active from "../images/Found/Active.png"

import { SpecialImage } from "./SpecialImage";

const foundItems = [
  {
    date: "March 1st 2026",
    badge: "✨(NEW)✨",
    title: "Ethan Kaloi Personal Website",
    link: "https://ethankaloi.com",
    content: "Kickass software dev with drive. Be sure to check back often for frequent updates and the long awaited book recommendation ai agent",
    image: Kaloi
  },
  {
    date: "March 1st 2026",
    badge: "✨(NEW)✨",
    title: "UP-DATE",
    link: "https://up-date.shop",
    content: "One of my great friends Greg Herrell has released an awesome product to help with your dating life! Meet up-date, the automated matchmaker. Gone are the days of pesky swiping on profiles for endless hours. Let up-date to the heavy lifting for you!",
    image: UpDate
  },
  {
    date: "Sept 1st 2025",
    title: "Mark Gouzoulis Personal Website",
    link: "https://markgouz.github.io/",
    content: "World renowned Software Enginner Mark Gouzoulis, known for his love of Python, debuts his personal site.",
    image: Mark
  },
  {
    date: "Jul 18th 2025",
    title: "Matt Gouzoulis Personal Website",
    link: "https://mgouz.dev",
    content: "World renowned Software Enginner Matthew Gouzoulis, known for his love of Emacs, debuts his personal site.",
    image: mattG
  },
  {
    date: "Jul 18th 2025",
    title: "Mac OS Svelte",
    link: "https://www.macos-web.app",
    content: "Very cool Mac OS sim in the browser!",
    image: MacOS
  },
  {
    date: "Nov 5th 2023",
    title: "UserInYrFace",
    link: "https://userinyerface.com",
    content: "If you are looking for insperation on how to design the most user friendly websites, look no further 😂"
  },
  {
    date: "Jan 1st 2023",
    title: "David Mount Independent Studies Homepage",
    link: "http://www.cs.umd.edu/~mount/Indep/index.html",
    content: "I was actually featured on this page for my college studies project. I wonder if its been updated recently... See the second entry titled 'VR Outrun Shooter by Andrew Dilks (Fall 2016). '",
    image: Mount
  },
  {
    date: "Jan 8th 2022",
    title: "Active Theory",
    link: "https://activetheory.net",
    content: "Have you ever seen such an advanced and complex while beautiful site? One day I hope to have skills like this!",
    image: Active
  },
  {
    date: "Jan 8th 2022",
    title: "3js Examples",
    link: "https://threejs.org/examples/#webgl_animation_keyframes",
    content: "I also aspire to be able to create 3d models - back when I used to be a VR dev, this was one of the hardest pieces of the process",
    image: ThreeJS
  },
];

const foundContentElements = (dark) => (
  <>
    <div className="col-md-6 p-3 container">
      <div className="h-100 p-5"
        style={ getStyle(dark) }
      >
        <ul style={{listStyleType: "none" }} >
          {
          foundItems.map((item, index) => {
            return (
                <li key={index} className={ `${ dark ? "text-white" : "" }` } >
                  { item.date }
                  {/* <br/> */}

                  {
                    item.badge? 
                    <h3>
                      { item.badge }
                    </h3> : <></>
                  }
                  

                  <a
                    style={{ paddingLeft: "1rem", fontSize: "large" }}
                    href={ item.link }
                    className={ `${ dark ? "text-white" : "" }` } >
                    <h4>
                      { item.title }
                    </h4>
                  </a>

                  <p className={ `${ dark ? "text-white" : "" }` }>
                    { item.content }
                  </p>

                  { item.image ? SpecialImage(item.image, '45%') : ""}

                  <br/>
                  <br/>
                  <hr style={{color: `${ dark ? "white" : "" }` }} />
                  <br/>
                  <br/>
                </li>
            )
          })
        }
      </ul>
      </div>
    </div>
    <br />
  </>
)

export default function Found(props) {
  const { dark } = props;

  return (
    <div>
      <center>
        { BWHeader(
            dark,
            "Found",
            "Here lies all of the content that I've found over the years that sparked my joy"
        ) }
        <br />
        { foundContentElements(dark) }
        { space18 }
      </center>
    </div>
  )
};
